import { pushQueries } from './pushQueries';
import { LOAD_MORE_QUERY_PARAMETER_NAME } from './queryParamNames';
import { useCurrentLoadMoreQuery } from './useCurrentLoadMoreQuery';
import { getQueryWithoutSlugTypeParameterFromParsedUrlQuery } from 'helpers/parsing/urlParsing';
import { useRouter } from 'next/router';
import { UrlQueries } from 'types/urlQueries';

export const useUpdateLoadMoreQuery = () => {
    const router = useRouter();
    const query = getQueryWithoutSlugTypeParameterFromParsedUrlQuery(router.query) as UrlQueries;
    const currentLoadMore = useCurrentLoadMoreQuery();

    const updateLoadMoreQuery = () => {
        const updatedLoadMore = currentLoadMore + 1;
        const newQuery: UrlQueries = {
            ...query,
            [LOAD_MORE_QUERY_PARAMETER_NAME]: updatedLoadMore > 0 ? updatedLoadMore.toString() : undefined,
        } as const;

        pushQueries(router, newQuery, true);
    };

    return updateLoadMoreQuery;
};
